import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export function LoginRecaptcha({ onChange, siteKey }: { onChange: (token: string|null) => void, siteKey: string }) {
  return (
    <div className="flex justify-center my-4">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onChange}
      />
    </div>
  );
}
